import React from 'react';
import { isArray } from 'lodash';

import './error.scss';

interface Props {
    messages: string | Array<string | string[]> | React.ReactNode[];
}

const Error: React.FC<Props> = ({ messages }) => {
    const msgs = isArray(messages) ? messages : [messages];

    const resultMsgs = msgs.map(subMsgs =>
        isArray(subMsgs) ? subMsgs : [subMsgs]
    );

    return (
        <div styleName="container" className="__app-Error-container">
            {resultMsgs.map((item, idx) => (
                <div styleName="error" key={idx}>
                    {item.map((msg, msgIdx) => (
                        <span key={msgIdx}>{`${msg} `}</span>
                    ))}
                </div>
            ))}
        </div>
    );
};

export default React.memo(Error);
